var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemPiechart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M12.02 4.001a7.999 7.999 0 1 1-2.091 15.726 8 8 0 0 1-5.858-6.662l.172-.024v-.007L11 11.231V4h1zm.98 8.768L6.654 14.46A5.886 5.886 0 1 0 13 6.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M10.5 10.768 3.76 12.573l-.001-.003-1.504.407a8.16 8.16 0 0 1-.049-3.778 8 8 0 0 1 4.68-5.568C8.05 3.139 9 3 10.5 3zm-2-5.453a6 6 0 0 0-.791.265 5.88 5.88 0 0 0-3.562 4.818L8.5 9.232z"
})));
export default SvgGemPiechart;